import React, {Component, useContext, useRef} from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import logo from "../../../resources/images/logo.png";
import Container from "react-bootstrap/Container";

class HomeObj extends Component {
    constructor(props) {
        super(props);

        this.state = {

        }
    }
    componentDidMount() {
    }
    componentWillUnmount() {
    }
    render() {
        return (
            <Container>
                <Row className="mt-4">
                    <Col md="12">
                        <p>Apps, websites en NFT's.</p>
                        <p>
                            E-mail: <a href="mailto://thomas@heerenmoeskops.nl">thomas@heerenmoeskops.nl</a><br/>
                            Tel.: <a href="tel://0634855644">0634855644</a>
                        </p>
                        <p>
                            KVK: <strong>84324384</strong><br/>
                            BTW: <strong>NL003952752B55</strong><br/>
                            Rek.: <strong>NL79RABO0376187719</strong><br/>
                        </p>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export function Home() {
    return <HomeObj></HomeObj>
};